import { Vector2 } from "api/types/sketch";
import { BumpArcConstruct } from "api/types/sketch";
import { constructBumpOutArc } from "../construct";
import { getControlPoint } from "functions/sketch/math";

export function drawPrintCutBumpOutArc(
  painter: any,
  start: Vector2,
  end: Vector2,
  distance: number,
  width: number,
  depth: number,
  angle: number,
  zoom: number
): void {
  const bump_construct: BumpArcConstruct = constructBumpOutArc(start, end, angle, distance, width, depth, zoom);
  painter.lineTo(bump_construct.start.X, bump_construct.start.Y);
  const p1: Vector2 = getControlPoint(bump_construct.start, bump_construct.end, 0.5, bump_construct.top);
  painter.quadraticCurveTo(p1.X, p1.Y, bump_construct.end.X, bump_construct.end.Y);
}
